<template>
  <div class="PerforMonthReport">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <reportTypeTwo :wayString="wayString" :placehold="placehold" :Title="Title"></reportTypeTwo>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import reportTypeTwo from "../../components/report/reportType2";
import storeanalysisreport from "./analysisreport.js";
export default {
  name: "analysisreport-PerforMonthReport",
  data() {
    return {
      openMenu: ["8"],
      wayString: "marketerMothRrport", //传递到子组件的方法名称
      Title: '个人招生执行检核表',
      placehold: "" //传递到子组件的placehold
    };
  },
  components: {
    PageNav,
    reportTypeTwo
  },
  created() {
    
    this.slider = this.$store.state.Slider;
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("analysisreport.less");
.PerforMonthReport {
  // height: 100vh;
  font-size: 20px;
}
</style>
